
import React from 'react';
import Footer from '@/components/Footer';

interface StandardFooterProps {
  className?: string;
}

const StandardFooter: React.FC<StandardFooterProps> = ({ className }) => {
  return (
    <div className={`w-full ${className || ''}`}>
      <Footer />
    </div>
  );
};

export default StandardFooter;
